<template>
  <el-dialog title="请假申请" :close-on-click-modal="false" v-model="dialogVisible" width="450px">
    <el-form :model="dataForm" ref="dataFormRef" :rules="dataRule" label-width="80px">
      <el-form-item label="请假原因" prop="reason">
        <el-input
          type="textarea"
          v-model="dataForm.reason"
          placeholder="请假原因"
          :autosize="{ minRows: 4, maxRows: 6 }"
          clearable="clearable"
        />
      </el-form-item>
      <el-form-item label="开始日期">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item prop="startDate" class="form-item">
              <el-date-picker
                v-model="dataForm.startDate"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                type="date"
                placeholder="开始日期"
                style="width: 100%;"
                :disabledDate="disabledDate"
                clearable="clearable"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item prop="startTime" class="form-item">
              <el-time-select
                v-model="dataForm.startTime"
                start='08:30'
                step='00:30'
                end='20:30'
                value-format="HH:mm"
                placeholder="选择时间"
                style="width: 100%;"
              ></el-time-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="截止日期">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item prop="endDate" class="form-item">
              <el-date-picker
                v-model="dataForm.endDate"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                type="date"
                placeholder="截止日期"
                style="width: 100%;"
                :disabledDate="disabledDate"
                clearable="clearable"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item prop="endTime" class="form-item">
              <el-time-select
                v-model="dataForm.endTime"
                value-format="HH:mm"
                start='08:30'
                step='00:30'
                end='20:30'
                placeholder="选择时间"
                style="width: 100%;"
              ></el-time-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="请假类型" prop="type">
        <el-radio-group v-model="dataForm.type">
          <el-radio :label="1">病假</el-radio>
          <el-radio :label="2">事假</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
			<span class="dialog-footer">
				<el-button size="default" @click="close">取消</el-button>
				<el-button type="primary" size="default" @click="dataFormSubmit">确定</el-button>
			</span>
    </template>
  </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, reactive, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { addLeave } from '@/api/leave'
import utils from '@/utils/utils'

const props = defineProps({
  modelValue: {
    type: Boolean,
    require: true,
    default: false
  }
})

const dialogVisible = ref(props.modelValue)
const emits = defineEmits(['update:modelValue', 'refreshDataList'])

const dataForm = reactive({
  reason: null,
  startDate: null,
  startTime: null,
  endDate: null,
  endTime: null,
  type: null
})

const dataRule = {
  reason: [{ required: true, message: '请假原因不能为空' }],
  startDate: [{ required: true, message: '开始日期不能为空' }],
  startTime: [{ required: true, message: '开始时间不能为空' }],
  endDate: [{ required: true, message: '截止日期不能为空' }],
  endTime: [{ required: true, message: '截止时间不能为空' }],
  type: [{ required: true, message: '请假类型不能为空' }]
}

const dataFormRef = ref()

const disabledDate = (date) => {
  return dayjs(date.toLocaleDateString()).isBefore(new Date().toLocaleDateString())
}

const dataFormSubmit = async () => {
  const data = {
    reason: dataForm.reason,
    start: dayjs(dataForm.startDate).format('YYYY-MM-DD') + ' ' + dataForm.startTime + ':00',
    end: dayjs(dataForm.endDate).format('YYYY-MM-DD') + ' ' + dataForm.endTime + ':00',
    type: dataForm.type
  }
  dataFormRef.value.validate(async valid => {
    if (valid) {
      dataFormRef.value.resetFields()
      const result = await addLeave(data)
      if (result) {
        utils.showSuccess('请求成功')
        dialogVisible.value = false
        emits('update:modelValue', false)
        emits('refreshDataList')
      }
    }
  })

}

const close = () => {
  dialogVisible.value = false
  emits('update:modelValue', false)
}

watch(() => props.modelValue, (value, o) => {
  dialogVisible.value = value
})
</script>
